// TODO - implement styled-system

// eslint-disable-next-line import/prefer-default-export
export const blockSizes = {
  sm: '27px',
  md: '35px',
  lg: '43px'
};
